import { render, staticRenderFns } from "./UserLayout.vue?vue&type=template&id=8ead23b6&scoped=true&"
import script from "./UserLayout.vue?vue&type=script&lang=ts&"
export * from "./UserLayout.vue?vue&type=script&lang=ts&"
import style0 from "./UserLayout.vue?vue&type=style&index=0&id=8ead23b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ead23b6",
  null
  
)

export default component.exports